import { ApiResponse, ApiBypass } from '../types/api';
import { apiUrl } from './http';

function bypassBaseUrl() {
    return `https://${window.location.host}/admin/data/sysvars.asp`;
}

export async function bypassLoad(sessionKey?: string): Promise<ApiBypass[]> {
    if (!sessionKey) {
        return [];
    }

    const url = `${bypassBaseUrl()}?get=UX-ApiBypass&SessionKey=${sessionKey}`;

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        const data = await response.text();
        return JSON.parse(data || '[]') as ApiBypass[];
    } catch (error) {
        console.error('Failed to load bypass data:', error);
        return [];
    }
}

export function bypassFind(
    bypasses: ApiBypass[],
    verb: string,
    url: string
): ApiResponse | undefined {
    const bypass = bypasses
        .filter(bypass => !bypass.disabled)
        .find(bypass => bypass.verb === verb && bypass.url === url);

    if (bypass && bypass.response) {
        let parsedResponse;
        try {
            parsedResponse = JSON.parse(bypass.response);
        } catch (error) {
            console.error('Failed to parse bypass response:', error);
            return undefined;
        }
        return {
            bypass: true,
            ok: true,
            status: 200,
            data: {
                data: parsedResponse
            },
            url: `https://${document.location.hostname}${apiUrl(url)}`
        };
    }

    return undefined;
}

export async function bypassSave(bypasses: ApiBypass[], sessionKey?: string) {
    if (!sessionKey) {
        return;
    }

    const url = `${bypassBaseUrl()}?SessionKey=${sessionKey}`;
    const urlEncodedData = new URLSearchParams();
    urlEncodedData.append('set', 'UX-ApiBypass');
    urlEncodedData.append('value', JSON.stringify(bypasses));

    const response = await fetch(url, {
        method: 'POST',
        body: urlEncodedData,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
    });

    return response;
}

export async function persistSession(sessionKey?: string) {
    if (!sessionKey) {
        return;
    }

    const url = `https://${window.location.host}/Login/persist.asp?SessionKey=${sessionKey}&_nocache=${Date.now()}`;

    const response = await fetch(url, {
        method: 'GET',
        mode: 'no-cors'
    });

    return response.text();
}
